import { useEffect } from "react";
import { onAuthStateChanged } from "../api";
import { useAuthUserStore } from "../stores/authUserStore";
import { useUserRoleStore } from "../stores/userRoleStore";
import { AdminRole } from "../types";

export const useAuth = () => {
  const { setFirebaseUser } = useAuthUserStore();
  const { setRoles } = useUserRoleStore();

  useEffect(() => {
    return onAuthStateChanged(async (user) => {
      if (!user) {
        setFirebaseUser(null);
        setRoles([]);
        return;
      }

      const tokenPayload = await user?.getIdTokenResult();
      const isAdmin = tokenPayload?.claims?.isAdmin;
      const roles = tokenPayload?.claims?.roles as AdminRole[];

      if (!isAdmin || !roles.length) {
        setFirebaseUser(null);
        setRoles([]);
        return;
      }

      setFirebaseUser(user);
      setRoles(roles);
    });

    // disabled ESLint because we need to call this hook only during the first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
